<template>
  <div style="background-color: #F9F9F9" class="overflow-x-auto overflow-hidden">
    <loading v-model:active="pageLoader" :can-cancel="false" loader="dots" color="#02C782" background-color="#818585"
      width="130" height="130" :is-full-page="true" />
    <div class="mx-2 relative mt-5 md:mt-5 overflow-x-auto overflow-hidden">
      <div class="flex justify-between items-baseline	">
        <h1 style="font-weight: 550;" class="text-2xl  mb-5 mt-10 "> Collection Console
        </h1>
      </div>
      <diV class="flex filter  mb-5">
        <!-- <div class="flex align-items-end"> -->
        <select @change="countryChanged" v-model="selectDistrictid" style="width: 300px;height: 40px;font-weight:500"
          id="selectDistrictid"
          class="font-family-card text-[16px] rounded  font-semibold bg-white border mr-3 border-gray-300 text-gray-900  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected value="all">All Cities</option>
          <option v-for="district in selectDistrict" :key="district.id" :value="district.id">{{ district.name
          }}</option>
        </select>
        <select multiple v-model="counteryid" id="hospitals" style="width: 400px;height: 40px;background: gray;"
          class="js-example-disabled-results bg-gray-50 rounded border mr-3 border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value=""></option>
          <option v-for="hospital in countries" :key="hospital.id" :value="hospital.id">{{ hospital.name }}
          </option>
        </select>
        <!-- </div> -->
      </diV>
      <div class="flex flex-wrap items-baseline	 mb-4 ">
        <div style="width: 120px;height: 40px;"
          class="flex items-center md:mb-5 rounded ps-4 border mr-3 border-gray-200  dark:border-gray-700">
          <input id="bordered-radio-1" type="radio" v-model="status" value="in_process" name="bordered-radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
          <label for="bordered-radio-1"
            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">In-Stock</label>
        </div>
        <div style="width: 120px;height: 40px;"
          class="flex  mr-5 items-center md:mb-5 rounded ps-4 border border-gray-200  dark:border-gray-700">
          <input checked id="bordered-radio-2" type="radio" v-model="status" value="incinerated" name="bordered-radio"
            class="w-4 h-4 text-blue-600  bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
          <label for="bordered-radio-2"
            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Disposed</label>
        </div>
        <div style="width: 100px;height: 40px;"
          class=" flex items-center rounded ps-4 md:mb-5 border border-gray-200  dark:border-gray-700">
          <input checked id="bordered-radio-3" type="radio" v-model="status" value="both" name="bordered-radio"
            class="w-4 h-4  text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
          <label for="bordered-radio-3"
            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Both</label>
        </div>
        <div class="lg:flex md:pt-5 sm:pt-0 sm:pb-0 pb-2 pt-2 " style="display: contents;">
          <div date-rangepicker class="flex md:pt-0 pt-5 flex-wrap items-center">
            <span class="text-gray-500 ms-2 me-2">Date From</span>
            <div class="relative mr-3">
              <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">

              </div>
              <input @change="validateDateRange" name="start" type="date" v-model="startDate"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Select Date From">
            </div>
            <span class="text-gray-500 me-2">Date To</span>
            <div class="relative sm:pt-0 sm:pb-0 pb-5 pt-5">
              <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">

              </div>
              <input @change="validateDateRange" name="end" type="date" v-model="endDate"
                class="bg-gray-50 border  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Select Date To">
            </div>
          </div>
          <div style="height: 40px;" class="flex md:pt-0 pt-5 items-center ps-4  dark:border-gray-700">
            <router-link to="" @click="clearFilter"
              class=" rounded-lg border text-border  border-border hover:bg-border hover:text-white  hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium  text-sm px-6 py-2  md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800">
              Clear
            </router-link>
          </div>
        </div>

        <div style="width: 130px;height: 40px;"
          class="flex md:pt-0 pt-5 ml-5 md:ml-0 items-center md:ps-4  dark:border-gray-700">
          <router-link to="" @click="applyFilters('isapply')"
            class="text-white rounded-lg   bg-bg-save hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium  text-sm px-5 py-2  md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800">
            Apply Filter
          </router-link>
        </div>

      </div>

      <div class="mb-5">
        <h1 class="text-border text-xl">Total Bags = {{ totalBags ?? '0' }}</h1>
        <h1 class="text-border text-xl">Total Weight (kg) = {{ totalweight ?? '0.00' }}</h1>
      </div>
      <div class="flex justify-between flex-wrap mb-5  items-baseline	"
        :class="{ 'justif-enddd': !hasEnterNewCollectionsPermission }">
        <router-link v-if="hasEnterNewCollectionsPermission" to="/collectionNewEntery"
          class="text-white bg-button-blue mb-5 md:mb-0 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:py-2.5 hover:bg-hover-blue dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
          New Collection
        </router-link>
        <div class="flex">
          <button v-if="hasExportPDFPermission" style="background-color:#02C782 ;" :disabled="isLoadingPdf"
            @click="handleexportpdf"
            class="text-white bg-bg-save hover:bg-hover-save  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative">
            {{ isLoadingPdf ? 'Exporting ' : 'Export PDF' }}
            <svg v-if="isLoadingPdf" aria-hidden="true" role="status" class="inline ms-2 w-4 h-4 text-white animate-spin"
              viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor" />
            </svg>
          </button>
          <button v-if="hasExportExcelPermission" style="background-color:#02C782 ;" :disabled="isLoadingExcel"
            @click="handleexportexcel"
            class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative">
            {{ isLoadingExcel ? 'Exporting ' : 'Export Excel' }}
            <svg v-if="isLoadingExcel" aria-hidden="true" role="status"
              class="inline ms-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor" />
            </svg>

          </button>
        </div>
      </div>
      <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
        <div>
          <span class="text-base">
            show:
            <select class="rounded-lg" id="quantity" @change="applyFilters('isapply')" v-model="number" name="quantity"
              style="border: 1px solid white; border-top: #F9F9F9;">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            &nbsp; entries
          </span>

        </div>

        <form>
          <label for="default-search"
            class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
          <div class="relative">

            <input type="search" v-model="searchQuery" style="padding-left: 20px; width: 350px; " id="default-search"
              class="block w-full p-4 pl-10 ps-20 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search" required>
            <button type="button" @click.prevent="handlesearch"
              class="text-white bg-button-blue absolute end-2.5 bottom-2  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-[10px] py-[12px] dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              <svg style="" class="w-10 h-4  text-white dark:text-gray-400" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
              </svg></button>
          </div>
        </form>

      </div>
      <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
        <table class="w-full border text-sm text-left rtl:text-right   text-gray-500 dark:text-gray-400">
          <thead class="text-xs border-collapse text-gray-700  bg-stone-300		 dark:bg-gray-900 dark:text-gray-400">
            <tr>
              <th style="width: 100px;" scope="" class="px-1 py-3 X border">
                Id
              </th>
              <th style="width: 200px;" scope="col" class="px-1 py-3 border">
                QR Code
              </th>
              <th style="width: 200px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Collected At
                </div>
              </th>
              <th style="width: 200px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  City
                  <a href="#"></a>
                </div>
              </th>
              <th style="width: 460px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Hospital
                </div>
              </th>
              <th style="width: 300px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Collector's Team
                </div>
              </th>
              <!-- <th scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Helper
                </div>
              </th> -->
              <th :style="tabledata.length > 0 ? 'width: 100px;' : 'width: 700px;'" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  WT (kg)

                </div>
              </th>
              <th style="width: 250px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Manager
                </div>
              </th>
              <th style="width: 350px;" scope="" class="px-1 py-3 w-[200px] border">
                <div class="flex items-center">
                  Scanned At
                </div>
              </th>
              <th style="width: 250px;" scope="" class="px-1 py-3 w-[200px] border">
                <div class="flex items-center">
                  Status

                </div>
              </th>
              <th style="width: 300px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Disposed Site

                </div>
              </th>
              <th style="width: 200px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Waste Handler

                </div>
              </th>
              <th style="width: 200px;" scope="col" class="px-1 py-3 border">
                <div class="flex items-center">
                  Disposed At

                </div>
              </th>
              <th class="px-1 py-3 border" v-if="hasdeletePermission">
                <span class="flex items-center">Delete</span>
              </th>
            </tr>
          </thead>
          <tbody class="" v-if="tabledata.length > 0">
            <tr v-for="(scan, index) in tabledata" :key="scan"
              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td class="px-1 py-1 border">{{ calculateSerialNumber(index) }}</td>
              <td class="px-1 py-1 border">{{ scan?.qr_code }}</td>
              <td class="px-1 py-1 border">{{ scan?.collected_at }}</td>
              <td class="px-1 py-1 border">{{ scan?.district?.name }}</td>
              <td class="px-1 py-1 border">{{ scan?.hospital?.name }}</td>
              <td class="px-1 py-1 border">
                <div class="tooltip">{{ scan?.collector_team }}
                  <span class="tooltiptext">{{ scan?.collectors_name }}</span>
                </div>
              </td>
              <!-- <td class="px-1 py-1 border">{{ scan?.helper_name }}</td> -->
              <td class="px-1 py-1 border"> {{ scan?.weight ? `${scan?.weight}` : '' }}
              </td>
              <td class="px-1 py-1 border">{{ scan?.dist_manager_name }}</td>
              <td class="px-1 py-1 border">{{ scan?.scanned_at }}</td>
              <td class="px-1 py-1 border">
                <span v-if="scan?.in_process"
                  class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">{{
                    scan?.status }}</span>
                <span v-else
                  class="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">{{
                    scan?.status }}</span>
              </td>
              <td class="px-1 py-1 border">{{ scan?.incinerated_site?.name }}</td>
              <td class="px-1 py-1 border">{{ scan?.handler_name }}</td>
              <td class="px-1 py-1 border">{{ scan?.incinerated_at }}</td>
              <td class="px-1 py-1 border" v-if="hasdeletePermission" style="cursor: pointer;">
                <a @click="deltecollection(scan?.id)"
                style="color: red;"
                  class="font-medium  dark:text-blue-500 hover:underline">Delete</a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4 text-base text text-gray-900">No Data found!</td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-end mt-2" v-if="tabledata.length > 0">
        <vue-awesome-paginate :total-items="totalpage" class="overflow-hidden pl-5" :items-per-page="1"
          :max-pages-shown="5" v-model="currentPage" :on-click="onClickHandler" :hide-prev-next-when-ends="true"
          next-button-content=">" />
      </div>

    </div>
  </div>
</template>


<script setup>
import { ref, watch, computed, onMounted, onUpdated ,onUnmounted} from 'vue';
import { useScanCodeStore } from '@/store/QRScanCode';
import axiosInstance from "@/plugins/axios"
import $ from 'jquery';
import 'select2';
const show = ref(false)
const currentPage = ref(1);
const number = ref(10)
const searchQuery = ref('');
const qrscancode = useScanCodeStore();
const isLoadingExcel = ref(false);
const isLoadingPdf = ref(false);
const counteryid = ref(null)
const totalBags = ref(0);
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
const pageLoader = ref(false);

const tabledata = ref([])
import Swal from 'sweetalert2';
// const tabledata = computed(() => qrscancode.getCollections)
const totalpage = ref()

const handlesearch = async (e) => {
  await applyFilters('isapply');
}

const clearFilter = async (e) => {
  status.value = 'both' // Use 'both' if both is true, else use the status value
  selectDistrictid.value = 'all'
  $('#hospitals').val([]).trigger('change');
  counteryid.value = []
  searchQuery.value = ''
  startDate.value = ''
  endDate.value = ''
  number.value = 10
  countryChanged();
  await applyFilters('isapply');
  currentPage.value = 1
}

onMounted(async()=>{
  await authStore.handlepermission()
})

onUnmounted(async()=>{
  await authStore.handlepermission()
})
const handleexportpdf = async () => {
  isLoadingPdf.value = true;
  try {
    const requestBody = {
      district_id: selectDistrictid.value,
      status: status.value ?? 'both', // Use 'both' if both is true, else use the status value
      hospital_ids: $('#hospitals').val(),
      search: searchQuery.value,
      date_from: startDate.value,
      date_to: endDate.value,
      limit: number.value
    };
    await qrscancode.getExcelpdf(requestBody); // Assuming this is an asynchronous function
  } catch (error) {
    console.error('Error exporting PDF:', error);
    // Handle errors as needed
  } finally {
    isLoadingPdf.value = false;
  }
}

const handleexportexcel = async () => {
  isLoadingExcel.value = true;
  try {
    // console.log($('#hospitals').val(),'idddddddd');
    const requestBody = {
      district_id: selectDistrictid.value,
      status: status.value ?? 'both', // Use 'both' if both is true, else use the status value
      hospital_ids: $('#hospitals').val(),
      search: searchQuery.value,
      date_from: startDate.value,
      date_to: endDate.value,
      limit: number.value
    };
    await qrscancode.getExcelExcel(requestBody); // Assuming this is an asynchronous function
  } catch (error) {
    console.error('Error exporting Excel:', error);
    // Handle errors as needed
  } finally {
    isLoadingExcel.value = false;
  }
}

const countries = ref([]);
const selectDistrict = ref([]);
const selectDistrictid = ref('all')
// const progress = ref()
const status = ref()
const startDate = ref()
const endDate = ref()
const totalweight = ref(0)
const next_page_urls = ref(false)
const pagniationpage = ref(false)
const chunk = ref(1)
const isapplys = ref(false)
//validation start end date
const validateDateRange = () => {
  const startDateObj = new Date(startDate.value);
  const endDateObj = new Date(endDate.value);

  if (startDateObj > endDateObj) {
    alert('To date must be greater or equal to from date');
    endDate.value = ''; // Reset end date to prevent an invalid date range
  }
};

// Function to fetch countries from API
const fetchCountries = async () => {
  try {
    const response = await axiosInstance.get('/assigned-collection-districts'); // Replace with your API endpoint
    const districts = response.data.data;
    countryChanged();

    // Extracting all district names
    const districtNames = districts.map(district => district);
    selectDistrict.value = districtNames;
  } catch (error) {
    console.error('Error fetching countries:', error);
    // Handle error or show error message
  }
};

const countryChanged = async () => {
  try {
    const response = await axiosInstance.get(`/assigned-districts/${selectDistrictid.value}/collection-hospitals`);
    const countery = response.data.data;
    const counterys = countery.map(countery => countery);
    countries.value = counterys
  } catch (error) {
    console.error('Error fetching district info:', error);
    // Handle error or show error message
  }
};
const applyFilters = async (isapply) => {
  pageLoader.value = true
  try {
    const requestBody = {
      district_id: selectDistrictid.value,
      status: status.value ?? 'both', // Use 'both' if both is true, else use the status value
      hospital_ids: $('#hospitals').val(),
      search: searchQuery.value,
      date_from: startDate.value,
      date_to: endDate.value,
      limit: number.value
    };
    if (isapply === 'isapply') {
      isapplys.value = true
      const requestBody = {
        district_id: selectDistrictid.value,
        status: status.value ?? 'both', // Use 'both' if both is true, else use the status value
        hospital_ids: $('#hospitals').val(),
        search: searchQuery.value,
        date_from: startDate.value,
        date_to: endDate.value,
        limit: number.value
      };
      const response = await axiosInstance.post(`collections/filter?page=${chunk.value}`, requestBody);
      tabledata.value = response.data.data.collections.data
      totalweight.value = response.data.data.totalWeight
      totalBags.value = response.data.data.collections.total
      totalpage.value = response.data.data.collections.last_page
      if (response.data.data.next_page_url > 0) {

        next_page_urls.value = true
      }
      currentPage.value = 1

      pagniationpage.value = false
    } else {
      isapplys.value = false
      const response = await axiosInstance.post(`collections/filter?page=${currentPage.value}`, requestBody);
      tabledata.value = response.data.data.collections.data
      totalweight.value = response.data.data.totalWeight
      totalBags.value = response.data.data.collections.total
      totalpage.value = response.data.data.collections.last_page
      if (response.data.data.next_page_url > 0) {

        next_page_urls.value = true
      }
    }
  } catch (error) {
    console.error('Error fetching district info:', error);
    // Handle error or show error message
  }
  pageLoader.value = false

};

const calculateSerialNumber = (index) => {
  // Calculate serial number based on page, limit, and index
  if (isapplys.value === true) {
    return index + 1
  }
  if (currentPage.value === 1) {
    return index + 1;
  } else {
    return (currentPage.value - 1) * number.value + index + 1;
  }
};
// Fetch countries when the component is mounte
onMounted(async () => {
  await fetchCountries();
  applyFilters()
  $(".js-example-disabled-results").select2({
    placeholder: "All Hospitals",
    allowClear: true
  });
})
const onClickHandler = async () => {
  await applyFilters()
  // pagniationpage.value =  true
}
const deltecollection = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You want to delete this collection?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  });

  if (confirmed.isConfirmed) {
    try {
      await axiosInstance.delete(`collections/${id}`);
      await applyFilters()
      Swal.fire(
        'Deleted!',
        'Your collection has been deleted.',
        'success'
      );
    } catch (error) {
      console.error('Failed to delete collection:', error);
      Swal.fire(
        'Error!',
        'Failed to collection collection.',
        'error'
      );
    }
  }
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
  permissions.value = authStore.authData.permissions

});
const hasEnterNewCollectionsPermission = computed(() => permissions.value.some(permission => permission.name === 'can enter new collections'));
const hasExportPDFPermission = computed(() => permissions.value.some(permission => permission.name === 'can export collection console pdf'));
const hasExportExcelPermission = computed(() => permissions.value.some(permission => permission.name === 'can export collection console excel'));
const hasdeletePermission = computed(() => permissions.value.some(permission => permission.name === 'can delete collections'));

</script>
<style>
@import '~select2/dist/css/select2.min.css';

.pagination-container {
  display: flex;
  column-gap: 5px;
}

.paginate-buttons {
  height: 30px;
  width: 36px;
  border-radius: 10px;
  cursor: pointer;
  /* background-color: rgb(242, 242, 242); */
  /* border: 1px solid rgb(217, 217, 217); */
  color: black;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* Ensure the loader stays on top */
}


.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #ffffff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border: solid #3F83F8 2px !important;
  outline: 0;
}

span.select2-selection.select2-selection--multiple {
  padding: 8px !important;
  background: padding-box !important;
}

.select2-container--default .select2-selection--multiple {
  background-color: white;
  border: 1px solid #aaaaaa82 !important;
  border-radius: 4px;
  cursor: text;
  padding-bottom: 5px;
  padding-right: 5px;
  position: relative;
}

.select2-container--default .select2-selection--multiple .select2-selection__clear {
  cursor: pointer;
  font-weight: bold;
  height: 20px;
  margin-right: 10px;
  margin-top: 5px;
  position: absolute;
  right: 0;
  padding: 1px;
  display: none !important;
}

.select2-container .select2-search--inline .select2-search__field {
  box-sizing: border-box;
  border: none;
  font-size: 100%;
  margin-top: -24px;
  margin-left: 5px;
  padding: 0;
  max-width: 100%;
  resize: none;
  height: 23px !important;
  vertical-align: bottom;
  font-family: sans-serif;
  overflow: hidden;
  word-break: keep-all;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.paginate-buttons:hover {
  background-color: #d8d8d8;
}

.active-page {
  background-color: yellow;
  border: 1px solid yellow;

  color: black;
}

.active-page:hover {
  cursor: pointer;
  background-color: yellow;
  border: 1px solid yellow;
}

span.select2-selection.select2-selection--multiple {
  padding: 8px !important;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted #40C782;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: #fff;
  color: #808080;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  border: 1px solid #40C782;
  bottom: -15px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>